import { FoodsIllustrations, WhiteBox } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Loading } from "src/components/utils/Loading";

export const ActionLoadingState = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Stack justifyContent={"center"} alignItems={"center"}>
            <WhiteBox>
                <Stack alignItems={"center"} gap={theme.spacing(2)} padding={theme.spacing(4, 8)}>
                    <FoodsIllustrations illustration={"congratulations"} />
                    <Stack flexDirection={"row"} justifyContent={"center"}>
                        <Typography variant="body-medium">{t("actionplan.creating")}</Typography>
                    </Stack>
                    <Loading />
                </Stack>
            </WhiteBox>
        </Stack>
    );
};
